import {KeyValue, SelectOption, Tenant, View} from './types/Types';
import {Value} from '@planday-corp/ui/types/Option';

export interface XeroSignupState<T extends Value> {
  hasSaved: boolean;
  signupRequestId: string;
  isLoading: boolean;
  displayCountryAndTimeZone: boolean;
  formData: KeyValue;
  errors: {
    fields?: KeyValue;
  };
  apiErrors: {
    fields?: KeyValue;
  };
  validationRules: {
    item: KeyValue;
  };
  view: View;
  industryOptions: Array<SelectOption<T>>;
  employeeOptions: Array<SelectOption<T>>;
  phonePrefixOptions: Array<SelectOption<T>>;
  countryOptions: Array<SelectOption<T>>;
  signupUrl?: string;
  tenants?: Tenant[];
  tenantId?: string;
  source?: string;
  signupOrigin?: string;
  hasAcceptedTerms: boolean;
  isPortalCreationInProgress: boolean;
  portalUrl?: string;
}

export const DEFAULT_STATE: XeroSignupState<string> = {
  hasSaved: false,
  signupRequestId: '',
  isLoading: false,
  displayCountryAndTimeZone: false,
  formData: {
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    email: '',
    companyName: '',
    countryCode: '',
    phone: '',
    phoneCountryCodePrefix: '',
    industry: '',
    noOfEmployeesRange: '',
    requestOrigin: '',
    isEmailInUse: false,
    timeZone: '',
  },
  validationRules: {
    item: {
      firstName: {required: true},
      lastName: {required: true},
      phone: {required: true},
      phoneCountryCodePrefix: {required: true},
      companyName: {required: true, maxLength: 60},
      industry: {required: true},
      noOfEmployeesRange: {required: true},
    },
  },
  errors: {},
  apiErrors: {},
  view: 'emptyView',
  industryOptions: [],
  employeeOptions: [],
  phonePrefixOptions: [],
  countryOptions: [],
  hasAcceptedTerms: false,
  isPortalCreationInProgress: false,
};
